import React from "react";
import ImageGallery from 'react-image-gallery';
import EventService from '../../../services/EventService';
import ToastService from '../../../services/ToastService';
import MasterService from '../../../services/MasterService';
import nofileSvg from '../../../public/nofile.svg';
import moment from "moment";
import { showLoading } from 'react-global-loading';
const today = new Date();
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';

class AddEditEvent extends React.Component {
  constructor(props) {
    super(props);

    const query = this.props.location?.search ? new URLSearchParams(this.props.location.search) : '';
    this.state = {
      eventId: query ? query.get('id') : '',
      categories: [],
      countries: [],
      selectedCountry: '',
      selectedCategory: [],
      selectedImages: [], imageIndex: 0, imageApi: '',
      eDesc: '',
      eName: '',
      pName: '',
      cName: '',
      eDateStart: "", eDateEnd: '', eTimeEnd: '',
      eTimeStart: '',
      selectedState: '',
      selectedCity: '',
      address: '',
      emailId: '',
      mobileNo: '',
      pincode: ''
    };

  }

  componentDidMount = () => {
    this.state.eventId ? this.getEventById(this.state.eventId) : '';
    this.getCategories();
    this.getAllCountries();
  };

  getAllCountries = () => {
    MasterService.getAyushCountries()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ countries: result });

      })
      .catch((err) => {
        console.error(err);
      });
  };

  getCategories = () => {
    MasterService.getCategories()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ categories: result });
      })
      .catch((err) => {

        console.error(err);
      });
  };

  getEventById = (id) => {
    EventService.getEventById({ "p": id })
      .then((result) => {
        if (!result) {
          return;
        }
        console.log("event update result", result)
        const catIds = [];
        result[0]?.category?.map((item, index) => catIds.push(item.name));
        this.setState({
          selectedCategory: catIds,
          selectedCountry: result[0].select_country?.id,
          imageApi: result[0].event_image,
          eDesc: result[0].post_content,
          eName: result[0].post_title,
          pName: result[0].practitioner_name,
          cName: result[0].clinic_name,
          eDateStart: result[0].start_date,
          eDateEnd: result[0].end_date,
          eTimeEnd: result[0].end_time,
          eTimeStart: result[0].start_time,
          selectedState: result[0].select_state,
          selectedCity: result[0].select_city,
          address: result[0].center_address,
          emailId: result[0].email_id,
          mobileNo: result[0].contact_number,
          pincode: result[0].pincode,
          status: result[0].post_status
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  deleteImage() {
    this.setState({ imageApi: '' });
    // this.setState({
    //   selectedImages: this.state.selectedImages.filter(image => image.thumbnail ===
    //     'https://picsum.photos/id/1019/250/150/')
    // });

    // const idx = this.state.selectedImages.getCurrentIndex();
    // this.state.selectedImages.slideToIndex(idx === 0 ? idx : idx - 1);
  }

  onImageSelection = (event) => {
    this.setState({
      selectedImages: [{
        original: URL.createObjectURL(event.target.files[0]),
        thumbnail: URL.createObjectURL(event.target.files[0]),
      }],
      imageApi: event.target.files[0]// [...this.state.imageApi, event.target.files[0]]
    });

  };

  handleCategories = (status, catId) => {
    if (status === true) {
      this.setState({
        selectedCategory: [...this.state.selectedCategory, catId]
      });
    }
    else {

      this.setState({ selectedCategory: this.state.selectedCategory.filter((item) => (item !== catId)) });
    }
  };

  myOnClick(event) {
    var currentIndex = this._imageGallery.getCurrentIndex();
    this.setState({ imageIndex: currentIndex });
  }

  onEventCreateUpdate = () => {
    const { eName,
      eDesc, pName, cName, eTime,
      selectedState,
      selectedCity, address,
      emailId, mobileNo, eventId,
      pincode, selectedCategory, selectedCountry, imageApi, status, eDateStart, eDateEnd, eTimeEnd, eTimeStart } = this.state;
    if (eName && eDateStart && eTimeStart && cName &&
      eDesc && selectedCategory && imageApi && (selectedCountry || userData.blog_id?.userblog_id)) {

      var emailregex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
      var mobPattern = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i);

      if (mobileNo) {
        if (!mobPattern.test(mobileNo) || mobileNo.length !== 10)
          return ToastService.error("Please enter valid mobile");
      }
      if (pincode) {
        if (pincode.length !== 6)
          return ToastService.error("Please enter valid pincode");
      }
      if (emailId) {
        if (!emailregex.test(emailId))
          return ToastService.error("Please enter valid email");
      }
      var data = new FormData();
      data.append('post_title', eName);
      data.append('post_content', eDesc);
      data.append('practitioner_name', pName);
      data.append('clinic_name', cName);
      data.append('start_date', eDateStart);
      data.append('end_date', eDateEnd);
      data.append('start_time', eTimeStart);
      data.append('end_time', eTimeEnd);
      data.append('select_state', selectedState);
      data.append('select_city', selectedCity);
      data.append('image_upload', imageApi);
      data.append('select_country', userData.roles === "administrator" && selectedCountry);
      data.append('center_address', address);
      data.append('pincode', pincode);
      data.append('contact_number', mobileNo);
      data.append('email_id', emailId);
      data.append("lang", localStorage.getItem('localLang'));
      data.append('category', selectedCategory);
      status && data.append('post_status', status);
      data.append('ID', eventId ? eventId : '');
      userData.roles === "administrator" ? data.append('blog_id', selectedCountry) : data.append('blog_id', userData.blog_id?.userblog_id);

      if (eventId) {
        EventService.updateEvent(data).then((result) => {
          result.status === 200 ? (
            ToastService.success(result.data.message),
            window.history.back()) :
            (ToastService.error(result.data.message),
              window.history.back());
        });
      }
      else {
        EventService.createEvent(data).then((result) => {
          result.status === 200 ? (
            ToastService.success(result.data.message),
            showLoading(false),
            window.history.back()) :
            (ToastService.error(result.data.message),
              showLoading(false),
              window.history.back());
        });
      }
    }
    else {
      return ToastService.error("Please fill required details");
    }

  };

  onHandleChange = (e) => {
    this.setState({
      emailId: e.target.value
    });
  };

  render() {
    const { selectedImages,
      categories, eName,
      eDesc, eDate, pName,
      cName, eTime,
      selectedState,
      selectedCity, address,
      emailId, mobileNo, countries, eDateStart, eDateEnd, eTimeEnd, eTimeStart,
      pincode, selectedCategory, selectedCountry, imageApi, eventId } = this.state;
    return (
      <div className="container bg-white m-ver-col" id="main">
        {/* {userData.roles === "administrator" ? '' : <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">{eventId ? "Update" : "Create"} Event</li>
          </ol>
        </nav>} */}
        <div className="row mt-3 bg-white">
          <div className="col-12">
            <div className="col-md-9">
              <h4 className="t0">{eventId ? "Update" : "Create New "} event</h4>
            </div>
          </div>
          {/* <h3><b>Name of the Event</b></h3> */}
          {/* <span className="text-primary d-block mb-2"><i className="fa fa-user-md" aria-hidden="true" /> Dr Vivek’s Naturopathy</span> */}

        </div>
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="form-group mb-3 position-relative">
              <label htmlFor="eventname" id="eventname" className="bldlbl t2">Event’s Name *</label>
              <input type="text" aria-labelledby="eventname" onChange={(e) => this.setState({ eName: e.target.value })} value={eName} className="form-control inpd" name="eventname" />
            </div>
            <div className="form-group mb-3 position-relative">
              <label htmlFor="practitionername" id="practitionername" className="bldlbl t2">Practitioner’s Name </label>
              <input type="text" value={pName} aria-labelledby="practitionername" onChange={(e) => this.setState({ pName: e.target.value })} className="form-control inpd" name="practitionername" />
            </div>
            <div className="form-group mb-3 position-relative">
              <label htmlFor="clinicname" id="clinicname" className="bldlbl t2">Clinic’s Name *</label>
              <input type="text" value={cName} aria-labelledby="clinicname" onChange={(e) => this.setState({ cName: e.target.value })} className="form-control inpd" name="clinicname" />
            </div>

            <div className="row">
              <div className="col-md-6 m-fg">
                <div className="form-group position-relative">
                  <label htmlFor="eventname" id="startdate" className="bldlbl t2">Event Start Date *</label>
                  <input type="date" className="form-control inpbr" aria-labelledby="startdate"
                    value={moment(eDateStart).format("yyyy-MM-DD")} //min={moment(today).format("yyyy-MM-DD")}
                    onChange={(e) => this.setState({ eDateStart: new Date(e.target.value) })} />
                </div >
              </div >
              <div className="col-md-6 m-fg">
                <div className="form-group position-relative">
                  <label htmlFor="eventname" id="starttime" className="bldlbl t2">Start Time *</label>
                  <input type='time' className="form-control inpbr" aria-labelledby="starttime" data-date-format="HH : MM : SS"
                    value={eTimeStart} onChange={(e) => this.setState({ eTimeStart: e.target.value })} />
                </div>
              </div>
            </div >
            <div className="row mt-3">
              <div className="col-md-6 m-fg">
                <div className="form-group position-relative">
                  <label for="eventname" id="enddate" className="bldlbl t2">Event End Date *</label>
                  <input type="date" className="form-control inpbr" aria-labelledby="enddate"
                    value={moment(eDateEnd).format("yyyy-MM-DD")} //min={moment(this.state.eDateStart).format("yyyy-MM-DD")}
                    disabled={!this.state.eDateStart}
                    onChange={(e) => this.setState({ eDateEnd: new Date(e.target.value) })} />
                </div>
              </div>
              <div className="col-md-6 m-fg">
                <div className="form-group position-relative">
                  <label for="eventname" id="endtime" className="bldlbl t2">End Time *</label>
                  <input type='time' className="form-control inpbr" aria-labelledby="endtime" data-date-format="HH : MM : SS"
                    value={eTimeEnd} onChange={(e) => this.setState({ eTimeEnd: e.target.value })} />
                </div>
              </div>
            </div>

            <div className="form-group mb-2 mt-3 position-relative">
              <label htmlFor="eventname" id="domains" className="bldlbl t2">Domains*:</label>
              <div className="btn-group d-block event-check" role="group" aria-label="Basic checkbox toggle button group">
                {categories.map((item, index) =>
                  < span key={index}> <input aria-labelledby="domains" type="checkbox" className="btn-check" id={index} autoComplete="off" checked={selectedCategory.includes(item.name)} onClick={(e) => this.handleCategories(e.target.checked, item.name)} />
                    <label className="btn btn-outline-dark" htmlFor={index}>{item.name}</label></span>)}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="slide_galleries">
              {imageApi ? <>

                <img src={imageApi.length > 0 ? imageApi[0] : URL.createObjectURL(imageApi)} />
                <div className="d-block del-btn">
                  <button onClick={() => this.deleteImage()}><i className="fa fa-trash" aria-hidden="true"></i></button>
                </div>
                {/* <ImageGallery
                ref={i => this._imageGallery = i}
                items={selectedImages}
                showThumbnails={false}
                thumbnailPosition="left"
                showFullscreenButton={false}
                showPlayButton={false}
                disableKeyDown={true}
                disableSwipe={true}
                disableThumbnailSwipe={true}
                showBullets={false}
                onClick={this.myOnClick.bind(this)}
              />   <div className="upload-box upload-indicator d-flex align-items-center justify-content-center">
              //     <i className="fa fa-plus-circle fs-2" aria-hidden="true" ></i>
              //     <input type="file" name="file" className="upload-btn" accept=".png, .jpg, .jpeg" onChange={this.onImageSelection} />
              //   </div> */}
              </> :
                <div className="upload-drag d-flex align-items-center justify-content-center">
                  <div className="uploadbox">
                    <img src={nofileSvg} className="d-block noimg" alt="upload" />
                    <span className="d-block">Upload Image by clicking </span>
                    <label htmlFor="productname" id="uploadimagg" className="bldlbl">Image for the event *</label>
                    <input className="upload-btn" aria-labelledby="uploadimagg" type="file"
                      accept="image/jpg, image/jpeg, image/png" name="file" onChange={this.onImageSelection} />
                  </div>
                </div>
              }
            </div>
          </div>

          <div className="col-12">
            <div className="form-group mb-3 position-relative">
              <label htmlFor="eventdescription" id="eventdesc" className="bldlbl t2">Event’s Description* </label>
              <textarea className="form-control inpd" rows="3" aria-labelledby="eventdesc" value={eDesc} onChange={(e) => this.setState({ eDesc: e.target.value })}></textarea>
            </div>
          </div>

          <div className="col-12 ">
            <div className="row">
              <div className="col-md-6">

                {userData.roles === "administrator" && <div className="form-group mb-3 position-relative">
                  <label htmlFor="countryname" id="selectcountryy" className="bldlbl t2">Select Country*</label>
                  <select name='orderby' className='form-control inpd' aria-labelledby="selectcountryy" value={selectedCountry}
                    onChange={(e) => this.setState({ selectedCountry: e.target.value })}>
                    <option defaultValue='selected'>Countries</option>
                    {countries.map((item, index) => <option key={index} value={item.id}>{item.blogname}</option>)}
                  </select>
                </div>}

                <div className="form-group mb-3 position-relative">
                  <label htmlFor="statename" id="selectstate" className="bldlbl t2">Select State</label>
                  <input type="text" value={selectedState} aria-labelledby="selectstate" onChange={(e) => this.setState({ selectedState: e.target.value })} className="form-control inpd" name="clinicname" />
                </div>

                <div className="form-group mb-3 position-relative">
                  <label htmlFor="cityname" id="selectcity" className="bldlbl t2">Select City</label>
                  <input type="text" value={selectedCity} aria-labelledby="selectcity" onChange={(e) => this.setState({ selectedCity: e.target.value })} className="form-control inpd" name="clinicname" />
                </div>

                <div className="form-group mb-3 position-relative">
                  <label htmlFor="pincode" id="pincode" className="bldlbl t2">Pin Code</label>
                  <input type="number" className="form-control inpd" aria-labelledby="pincode" name="pincode" pattern="[0-9]{4}"
                    maxLength="6" value={pincode} onChange={(e) => { this.setState({ pincode: e.target.value }); }} />
                </div>

              </div>
              <div className="col-md-6">
                <div className="form-group mb-3 position-relative">
                  <label htmlFor="centeraddress" id="centeraddrs" className="bldlbl t2">Center’s Address</label>
                  <textarea className="form-control textarea-height inpd" aria-labelledby="centeraddrs" name="centeraddress" rows="3" value={address} onChange={(e) => this.setState({ address: e.target.value })} />                 </div>
                <div className="form-group mb-3 position-relative">
                  <label htmlFor="contactnumber" id="contactnumbr" className="bldlbl t2">Contact Number</label>
                  <input type="number" className="form-control inpd" aria-labelledby="contactnumbr" name="contactnumber" value={mobileNo} onChange={(e) => this.setState({ mobileNo: e.target.value })} />
                </div>
                <div className="form-group mb-3 position-relative">
                  <label htmlFor="mailid" className="bldlbl t2" id="emailid">E-mail Id</label>
                  <input type="email" className="form-control inpd" aria-labelledby="emailid" name="mailid" value={emailId} onChange={(e) => this.setState({ emailId: e.target.value })} />
                </div>
              </div>
            </div>

          </div>

          <div className="col-12 p-3 mb-4">
            <div className="rw_">

              <div className="btrw">
                <div className="mob-btn-col">
                  <button type="button" onClick={() => window.history.back()} className="card-link rounded rounded-2 w-100 btntxdsh lightbtn">Discard</button>
                </div>
                <div className="text-end mob-btn-col">
                  <button type="button" className="card-link rounded rounded-2 w-100 btntxdsh darkbtn" onClick={() => this.onEventCreateUpdate()}>{eventId ? "Update" : "Save"}</button>
                </div>
              </div>

            </div>
          </div>
        </div >
      </div >
    );
  }
}

export default AddEditEvent;